import { Helmet } from 'react-helmet'
import { PROPOSAL_TYPE_NAME } from '../../../constants/proposalTypes'
import CommonPage from '../../../containers/Proposal/Common/CommonPage'

const withCommonPage = WrappedComponent => props => {
  const { proposalType } = props

  return (
    <CommonPage>
      <Helmet key='HelmetCompo'>
        <title>{PROPOSAL_TYPE_NAME[proposalType]}</title>
      </Helmet>
      <WrappedComponent
        key='MainCompo'
        {...props}
      />
    </CommonPage>
  )
}

export default withCommonPage
